exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal{padding-left:0!important}.modal-full-screen-scrolling{height:calc(100% - 20px)}.modal-full-screen-scrolling .modal-content{height:100%}.modal-full-screen-scrolling .modal-content .modal-body{height:calc(100% - 118px);overflow-y:scroll}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/~/eoxc/src/core/views/ModalView.css
// module id = 1971
// module chunks = 0